import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Logo from "./logo";
import { Link, Skeleton } from "@mui/material";
import { useArcAuth } from "@arcauth/react-sdk";
import { getInitials } from "./util/encrypt.decrypt";
import { getUserInfo } from "../redux/features/user.slice"; 
import { useSelector } from "react-redux";
import { RootStateType } from "../redux/features/rootSlice";

function AppHeader() {

  // const {user} = useArcAuth();
  const {userLoading} = useSelector(
    (state: RootStateType) => state.userStateReducer
  );
  let user = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
 const headerText = getInitials(user?.firstname);
  return (
    <AppBar
      position="sticky"
      component={"header"}
      role="header"
      color="transparent"    
      tabIndex={1}  
      sx={{ backgroundColor: 'white' , boxShadow: "0px 1px 14px 0px rgba(0,0,0,.1)", px: 3, zIndex: 2 }}
    >
        <Toolbar  disableGutters>
          <Box component={"nav"} aria-label="Main navigation" sx={{img :{maxWidth:'200px',maxHeight:40, display: 'block', objectFit: 'cover', height: '100%', width: '100%'}}}>
            <Logo />
          </Box>

          <Box ml={"auto"}>
            {userLoading?<>
              <Skeleton
            variant="circular"
            width={40}
            height={40}

          />
            </>:<>
            
            <Avatar sx={{ width: 40, height: 40, backgroundColor:"#6D6D88" }}>
            {user?.imageurl ?
              (<img crossOrigin="anonymous" src={`${user?.imageurl}`} alt="" width={40} height={40} style={{objectFit: 'cover', display: 'block', height: '100%', width: '100%'}}/>)
              : (headerText)}
          </Avatar> 
            </>}

          </Box>
        </Toolbar>
    </AppBar>
  );
}
export default AppHeader;
